import AnalyticsDesign from "../../AnalyticsDesign/AnalyticsDesign";
// import Card from "../../Card/Card";

// Analytics.jsx
const Analytics = () => {
  return (
    <>
      <AnalyticsDesign />
    </>
  )
};

export default Analytics;